import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslate, } from 'react-admin';
import CustomPopoverArrow from '../../CustomizedUIs/CustomPopoverArrow'

const useStyles = makeStyles(theme => ({
    btnClose: {
        fontFamily: "UniviaPro",
        fontSize: "10px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.4px",
    }
}));

function ListItemPopover({ popupState, children, childrenPopup }) {
    const classes = useStyles();
    const translate = useTranslate();
    return (
        <CustomPopoverArrow
            zIndex={1550}
            popupState={popupState}
            placement='right-start'
        >
            <Paper style={{ width: 172, padding: 8 }}>
                {childrenPopup && childrenPopup.isOpen && <div onClick={childrenPopup.close} style={{ width: '100%', height: '100%', zIndex: 2000, position: 'absolute', overflow: 'hidden', top: 0, left: 0 }}></div>}

                {children}
                <Box display='flex' justifyContent='flex-end'>
                    <Button
                        color='primary'
                        type='button'
                        className={classes.btnClose}
                        onClick={popupState.close}

                    >{translate('pos.common.close')}</Button>
                </Box>
            </Paper>
        </CustomPopoverArrow>
    )
}

ListItemPopover.propTypes = {
    popupState: PropTypes.object
}

export default ListItemPopover;
